import { render, staticRenderFns } from "./checkout-products.vue?vue&type=template&id=ee3d8dfe&"
import script from "./checkout-products.vue?vue&type=script&lang=js&"
export * from "./checkout-products.vue?vue&type=script&lang=js&"
import style0 from "./checkout-products.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee3d8dfe')) {
      api.createRecord('ee3d8dfe', component.options)
    } else {
      api.reload('ee3d8dfe', component.options)
    }
    module.hot.accept("./checkout-products.vue?vue&type=template&id=ee3d8dfe&", function () {
      api.rerender('ee3d8dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-products.vue"
export default component.exports